import React, { ChangeEvent, FC } from 'react';
import {
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';
import {
  Form,
  InputsWrapper,
} from 'src/components/Forms/CreateAccountForm/styled';
import { PasswordInput } from 'src/components/Forms/FormInputs/PasswordInput';
import { Link } from 'src/components/Link/styled';
import { ROUTE_SOURCES } from 'src/constants/routeSources';
import { ModalTerminiCondizioni } from 'src/components/Modals';
import { Button as MuiButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ModalPrivacyPolicy } from 'src/components/Modals';
import { useState } from 'react';
import { useGoogleAnalytics } from 'src/hooks/useGoogleAnalytics';

export interface CreateAccountFormValues {
  policy: boolean;
  password: string;
  email: string;
  repeatPassword: string;
  firstName: string;
  lastName: string;
}

interface CreateAccountFormProps {
  onClick: () => void;
}

export const CreateAccountForm: FC<CreateAccountFormProps> = ({ onClick }) => {
  const { trackFormSubmit, trackFormStart } = useGoogleAnalytics();
  const {
    formState: { errors, isValid },
    register,
    setValue,
    watch,
    trigger,
  } = useFormContext<CreateAccountFormValues>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === 'password') {
      trigger('repeatPassword');
    }

    setValue(name as keyof CreateAccountFormValues, value, {
      shouldValidate: true,
    });
  };

  const handleFormStart = () => {
    trackFormStart('signup', 'auth');
  };

  const handleFormSubmit = () => {
    trackFormSubmit('signup', 'auth');
    onClick();
  };

  const [openTerms, setOpenTerms] = useState(false);
  const [openPrivacy, setOpenPrivacy] = useState(false);

  return (
    <Form>
      <InputsWrapper>
        <TextField
          {...register('firstName', { onChange: handleChange })}
          label="First name"
          name="firstName"
          error={!!errors.firstName}
          helperText={errors.firstName?.message || ' '}
          onFocus={handleFormStart}
        />
        <TextField
          {...register('lastName', { onChange: handleChange })}
          label="Last name"
          name="lastName"
          error={!!errors.lastName}
          helperText={errors.lastName?.message || ' '}
        />
        <TextField
          {...register('email', { onChange: handleChange })}
          label="Email"
          name="email"
          error={!!errors.email}
          helperText={errors.email?.message || ' '}
        />
        <PasswordInput
          error={!!errors.password}
          helperText={errors.password?.message || ' '}
          label="Password"
          name="password"
          onChange={handleChange}
        />
        <PasswordInput
          error={!!errors.repeatPassword}
          helperText={errors.repeatPassword?.message || ' '}
          label="Repeat password"
          name="repeatPassword"
          onChange={handleChange}
        />
      </InputsWrapper>
      <FormControlLabel
        control={
          <Checkbox checked={!!watch('policy')} {...register('policy')} />
        }
        label={
          <Typography variant="body2">
            By signing up, you agree to our{' '}
            <span
              style={{
                color: '#00bfa6',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
              onClick={() => setOpenTerms(true)}
            >
              Terms of Service
            </span>{' '}
            and{' '}
            <span
              style={{
                color: '#00bfa6',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
              onClick={() => setOpenPrivacy(true)}
            >
              Privacy Policy
            </span>
            .
          </Typography>
        }
      />
      <Button
        variant="contained"
        fullWidth
        disabled={!isValid}
        onClick={handleFormSubmit}
      >
        Next
      </Button>
      <ModalTerminiCondizioni
        open={openTerms}
        onClose={() => setOpenTerms(false)}
      />
      <ModalPrivacyPolicy
        open={openPrivacy}
        onClose={() => setOpenPrivacy(false)}
      />
    </Form>
  );
};
